/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const OpportunityPointJsonApiModel = {
  id: "",
  "key-point": "",
  "sort-order": "",
  opportunity: {
    jsonApi: "hasOne",
    type: "opportunities",
  },
  "opportunity-id": "",
  "manager-id": "",
  "created-at": "",
  "updated-at": "",
};
